import Config from 'Config';
const TOKEN_CACHE = 'token';

export interface LSToken {
  token: string;
  user: string;
}

export function deleteToken(): void {
  localStorage.removeItem(TOKEN_CACHE);
}

export const redirectToLogout = (finalDestination: string) => {
  const redirect = encodeURIComponent(finalDestination);
  window.location.href = `${Config.rtsProUrl}/logout?finaldestination=${redirect}`;
};

export const redirectToV2Logout = () => {
  window.location.href = `${Config.rtsProUrl}/v2/logout`;
};

export function setToken(token: LSToken): void {
  localStorage.setItem(TOKEN_CACHE, JSON.stringify(token));
}

export function isAuthed(): boolean {
  return !!localStorage.getItem(TOKEN_CACHE);
}

export function getToken(): LSToken {
  return JSON.parse(localStorage.getItem(TOKEN_CACHE));
}
